<template>
  <div>
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel height="180px">
        <el-carousel-item v-for="(item,i) of banner" :key="i"> 
        <a :href="item.link"><img :src="item.img" /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 静态文字+立即合成跳转 -->
    <div class="content-text">
      <div class="text-top">文字转语音</div>
      <div class="text-middle">——输入文字，立即合成配音——</div>
      <div class="content-middle">
        <div>
          <img src="../assets/images/feiyong.png" alt="" />
          <p>费用低</p>
          <p>价格远低于真人</p>
        </div>
        <div>
          <img src="../assets/images/duoyuyan.png" alt="" />
          <p>音色众多</p>
          <p>普通话、英语等百款主播</p>
        </div>
        <div>
          <img src="../assets/images/fuwu.png" alt="" />
          <p>优质服务</p>
          <p>尽职尽责服务用户</p>
        </div>
        <div>
          <img src="../assets/images/sudu.png" alt="" />
          <p>高效便捷</p>
          <p>输入文字秒变声音</p>
        </div>
      </div>
      <div class="btn-hecheng">
        <router-link to="/hecheng">立即合成配音</router-link>
      </div>
    </div>

    <!-- 配音主播 -->
    <div class="content-muban">
      <div class="muban-content">
        <p class="muban-title">配音主播</p>
        <div class="show_more">
          <router-link to="/peiyin">更多<i data-v-87b8f142="" class="el-icon-arrow-right"></i></router-link>
          
        </div>
      </div>

      <div class="itemblock">
        <div class="anchor-item" v-for="(item, index) of data.slice(0,16)" :key="index">

          <div class="anchor-item1" @click="play(item)">
              <div  class="anchor-specific">
                  <div  class="anchor-info-index">
                      <div  class="anchor-imgstyle">
                        <img  :src="item.imgurl" alt="主播头像" class="anchor-img">

                        <img :src="require('../assets/images/stopvideo.png')" v-if="playId == item.id" class="anchor-play" />

                        <img v-else :src="require('../assets/images/playvideo.png')" alt="播放" class="anchor-play">
                          <!---->
                      </div>
                      

                  </div>
                      <div  class="anchor-name"> {{item.anchorName}} 
                        <div  class="anchor-desc"> {{item.musicName}} </div>
                  </div>
              </div>
          </div>

        </div>     
      
      </div>
    </div>
    

    <!-- 他们都选择了使用我们培音 -->
    <div class="changWe">
      <p class="changeWe-title">他们都选择使用我们的配音</p>
      <div class="changWe-Middle">
        <el-carousel :autoplay="false" arrow="always" height="220px" class="show_card">
          <el-carousel-item>
            <div v-for="(item,index) of anli" :key="index" class="bigshow-item">
                <div >
                    <img  :src="item.imgurl" alt="头像" class="bigshow-imgurl">
                    <div  class="fans">
                        <div  class="fans-num">粉丝 1000W+</div>
                    </div>
                    <div  class="bigshow-name">{{item.name}}</div>
                    <div  class="bigshow-desc"> {{item.desc}} </div>
                </div>
            </div>
          </el-carousel-item>
          

        </el-carousel>
        
      </div>
    </div>

  <audio :src="mp3url" ref="audio" style="display:none;" @pause="pause()"> 
  </audio>

  </div>

</template>

<style>
.anchor-item:hover{
  display:flex;
  transform:scale(1.05);
  cursor:pointer;
  transition:all .2s
}
.anchor-item:hover .anchor-play{
  visibility:visible !important;
}


.itemblock {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    
    margin: 50px auto 0 auto;
    justify-content: center;
    border-top:1px solid #f1f1f1;
}
.anchor-item {
    margin-top: 1.6vw;
    width: 15.53333vw;
    height: 7.53333vw;
    margin-right: 2.8vw;
    position: relative;
}
.itemblock .anchor-item:nth-child(4n+1) .anchor-item1 {
  background-image: url('../assets/images/anchor1.png');
}

.itemblock .anchor-item:nth-child(4n+2) .anchor-item1 {
  background-image: url('../assets/images/anchor2.png');
}

.itemblock .anchor-item:nth-child(4n+3) .anchor-item1 {
  background-image: url('../assets/images/anchor3.png');
}

.itemblock .anchor-item:nth-child(4n+4) .anchor-item1 {
  background-image: url('../assets/images/anchor4.png');
}
.anchor-item1 {
    width: 15.53333vw;
    height: 7.53333vw;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    
}
.anchor-specific {
    display: flex;
}
.anchor-info-index {
    width: 3.6vw;
    height: 3.6vw;
    position: relative;
}
.anchor-imgstyle {
    width: 3.6vw;
    height: 3.6vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.anchor-img {
    width: 3.6vw;
    height: 3.6vw;
    border-radius: 50%;
}
.anchor-play {
    position: absolute;
    width: 2.13333vw;
    height: 2.13333vw;
    visibility:hidden;
}
.anchor-name {
    font-size: 1.26667vw;
    
    font-weight: bold;
    color: #333;
    margin-left: 1.06667vw;
    width: 6.66667vw;
}
.anchor-desc {
    font-size: 0.66667vw;
    
    font-weight: 500;
    color: #838383;
    margin-top: 0.4vw;
}

.show_card{
  width:76%;
  height:100%;
  margin:0 auto;
}

.bigshow-item {
    width: 14.13333vw;
    height: 11.93333vw;
    background: #fff;
    border: 1px solid #fff;
    box-shadow: 0px 1px 0.8vw 1px #f3f3f3;
    border-radius: 1.06667vw;
    
    cursor: pointer;
    text-align: center;
    margin: 2.8vw 10px 0 10px;
    position: relative;
}
.bigshow-imgurl {
    border-radius: 50%;
    position: absolute;
    width: 5.46667vw;
    height: 5.46667vw;
    top: -2.66667vw;
    left: 4.6vw;
}
.fans {
    position: absolute;
    left: 3.66667vw;
    top: 2vw;
    width: 7.73333vw;
    height: 2.46667vw;
    background-color:#3b3b3b;
    border-radius: 30px;
    box-shadow:0px 3px 0px 0px #bdeceb,
                3px 1px 0px 0px #ea4137;

    display: flex;
    justify-content: center;
    align-items: center;
}
.bigshow-name {
    font-size: 1.33333vw;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #333;
    margin-top: 5.33333vw;
}
.bigshow-desc {
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    margin: 0 1.33333vw;
    margin-top: 0.8vw;
}
.fans-num {
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: bold;
    color: #fff;
}
.el-carousel__item {
  display:flex !important;
  justify-content: center;
}
</style>
<script>
export default {
  data() {
    return {
      mp3url:"",
      anchor_index:-1,
      isPlay: false,
      playId:0,
      activeIndex:"1",
      data:[],
      anli:[
        {
          "imgurl":require('../assets/images/bigshot4.png'),
          "name":"抖音某博主",
          "desc":"“越来越多的解说朋友都在用，收费低功能强大“"
        },
        {
          "imgurl":require('../assets/images/bigshot6.png'),
          "name":"喜马拉雅作者",
          "desc":"“小说配音利器，方便快捷，比真人配音省力不少“"
        },
        {
          "imgurl":require('../assets/images/bigshot5.png'),
          "name":"番茄阅读作者",
          "desc":"“AI配音解决了人力成本的难题，收听体验也不差“"
        },
        {
          "imgurl":require('../assets/images/bigshot9.png'),
          "name":"蜻蜓FM大V",
          "desc":"“真的很方便，用了之后再也不用担心被催更了！“"
        }
      ],
      banner:[]
    
    };
  },
  methods: {
    //全部样音数据
    getData() {
      let that = this
      this.axios({
        method: "post",
        url: "/api/tts/list",
        data: {},
      })
        .then((res) => {
          this.data= res.data.data.items
          console.log(this.data)
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    play(item,e){

      if(this.isPlay){
        let plid = this.playId;
        this.stop();
        if(plid == item.id){
          console.log("stop")
          return;
        }
      }

      console.log("play "+item.id);
      
      this.mp3url = item.demoUrl;
      this.playId = item.id;
      console.log(this.mp3url)
      
      if(this.$refs.audio.readyState != 4){
        this.$refs.audio.oncanplay =()=>{
            this.playAdu();
        }
      }else{
        this.playAdu();
      }
      
    },
    stop(){
      this.$refs.audio.pause();
      this.isPlay = false;
      this.playId = 0;
    },
    pause(){
      this.isPlay = false;
      this.playId = 0;
    },
    playAdu(){
      this.isPlay = true;
      this.$refs.audio.play();
    },

    getBanner(){
      
      this.axios({
        method: "post",
        url: "/api/tts/banner",
        data: {},
      }).then((res) => {
        this.banner= res.data.data
        
      })
      .catch((err) => {
        console.log(err);
      });
    }
    
    
  },

  mounted() {
    this.getData();
    this.getBanner();
    this.$store.commit("setActiveIndex",this.activeIndex)
  },
};
</script>
